module.exports = __webpack_public_path__ + "img/logout.4849e6c0.svg";